// vendor
import { defineComponent, computed, ref, PropType, set } from "@vue/composition-api";
// local
import * as ItemTypes from "../ts/ItemTypes";
import ItemPreviewModal from "../vue/item-preview-modal.vue";
import EditCommentModal from "../vue/edit-comment-modal.vue";
import { default as PlatformButton } from "../vue/platform-button.vue";
import { FormItem } from "../ts/types";

const isQuestion = (itemType:string) => [ "Information", "HTML" ].indexOf(itemType) < 0;

export const createComponent = () => {
	return defineComponent({

		props:{
	
			dragging:{
				type:Boolean,
				default:false
			},
			icon:{
				type:String,
				default:""
			},
			data:{
				type:Object as PropType<FormItem<any>>,
				required:true
			}
	
		},
		components: {
			ItemPreviewModal,
			EditCommentModal,
			PlatformButton,
		},
		setup(props){
	
			const previewModal = ref<any>();
			const editCommentModal = ref<any>();
	
			const id = computed(() => props.data.id);
			const type = computed(() => props.data.type);
			const namePlaceholder = computed(() => "Name");
	
			const itemEditor = computed(() => {
				let i = (ItemTypes as any)[type.value].editor;
				return i ? i : ItemTypes["Default"].editor;
			});
			
			const showPlatforms = computed(() => !isQuestion(type.value));
	
			const showName = computed(() => true);
	
			const showRequired = computed(() => isQuestion(type.value));
	
			const name = computed({
				get:() => props.data.name,
				set:v => set(props.data, "name", v)
			});
	
			const hideName = computed({
				get:() => props.data.hideName,
				set:v => set(props.data, "hideName", v)
			});
	
			const optional = computed({
				get:() => props.data.optional,
				set:v => set(props.data, "optional", v)
			});
	
			const comment = computed({
				get:() => props.data.comment,
				set:v => set(props.data, "comment", v)
			});
	
			const openPreview = () => {
				if(previewModal.value){
					previewModal.value.open();
				}
			};
	
			const editComment = () => {
				if(!editCommentModal.value){ return; }
				editCommentModal.value.open({ value:props.data.comment || "" }, (newValue:string) => {
					comment.value = newValue;
				});
			};
	
			return {
				previewModal,
				editCommentModal,
				id,
				type,
				namePlaceholder,
				itemEditor,
				showName,
				showRequired,
				name,
				hideName,
				optional,
				comment,
				showPlatforms,
				openPreview,
				editComment,
			};
		}
	});
};